export default "//yastatic.net/s3/distribution/pythia/frontend/_/cbf0cb79c55b9691c7f1ae177809df02.svg";